import React, { Component } from 'react'
import SpecialKeysReact from 'special-keys-react'
import { Formik, Form, Field } from 'formik'
import { connect } from 'react-redux'
import { range } from 'lodash'
import * as Yup from 'yup'

import AuthErrorBox from 'components/Auth/AuthErrorBox'
import Logo from 'components/Logo/Logo'
import LoadingButton from 'components/ui/LoadingButton/LoadingButton'
import CheckboxItem from 'components/CheckboxItem/CheckboxItem'
import BackIcon from 'assets/back-icon.png'

import { sessionApi } from 'api'
import {
  SET_PAIN_AFTER_LEVEL,
  SET_PAIN_BEFORE_LEVEL,
  RESET_PAIN_LEVELS_AND_SESSION_ID,
} from 'store/actions/actionTypes'

import history from 'utils/appHistory'
import { ANXIETY, AWAKENING, SLEEP } from 'utils/constants'
import { updateSession } from 'utils/sqlite'

import { t } from 'translation'
import { addSongToHistory, authFail, resetAuthError } from 'store/actions'
import { inviteApi } from 'api'

import CloseIcon from '../assets/icons/close_2.svg'

const sendEmailSchema = Yup.object().shape({
  email: Yup.string().email('INVALID_EMAIL').required('EMAIL_IS_REQUIRED'),
})

class PainRatingPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      chosen: false,
      isProAfterPain: false,
      isLoading: false,
      success: false,
      currentPain: -1,
    }

    if (!this.props.indicationType) {
      const redirectPath = this.props.isDoctor ? `/welcome-doctor` : '/indication-select'
      history.replace(redirectPath)
    }

    if (!this.props.songId) history.replace('/song-select')

    if (
      !this.isBefore &&
      (typeof this.props.playedTime !== 'number' ||
        Number.isNaN(this.props.playedTime) ||
        this.props.playedTime < 60)
    )
      history.replace('/song-select')

    SpecialKeysReact.config({
      left: () => {
        this.backBtn.current.click()
      },
      right: () => {
        this.painRef.current[
          this.state.currentPain + 1 > this.painRef.current.length - 1
            ? 0
            : this.state.currentPain + 1
        ].focus()
        this.setState({
          currentPain:
            this.state.currentPain + 1 > this.painRef.current.length - 1
              ? 0
              : this.state.currentPain + 1,
        })
      },
      up: () => {},
      down: () => {},
      backspace: () => {},
      enter: () => {
        if (this.painRef.current[this.state.currentPain] !== -1)
          this.choosePainRatingHandler(this.state.currentPain)
      },
    })

    this.mainElement = React.createRef()
    this.backBtn = React.createRef()
    this.painRef = {
      current: [],
    }
  }

  isBefore =
    this.props.painLevelBefore === null &&
    this.props.indicationType !== SLEEP &&
    this.props.indicationType !== AWAKENING

  componentDidMount() {
    this.mainElement.current.focus()
  }

  choosePainRatingHandler = async (newRating) => {
    // Ignore another click if it occurs during the setTimeout
    if (this.state.chosen) return
    this.setState({ chosen: true })

    if (this.isBefore) {
      this.props.setPainLevelBefore(newRating)
      return setTimeout(() => history.replace('/player'), 500)
    }

    this.props.setPainLevelAfter(newRating)
    //this.props.addSongToHistory()
    if (this.props.sessionId && typeof this.props.playedTime === 'number') {
      // Session end api call here if give rating after session
      const data = {
        id: this.props.sessionId,
        playTime: this.props.playedTime,
        painAfter: newRating,
        endEvent: this.props.endEvent || 'songEnd',
        sessionEnd: new Date(),
      }

      if (!window?.cordova || this.props.sessionOnline) {
        sessionApi
          .sendSessionInfoAfter(data)
          .then(
            ({ error }) => error && console.log('Error updating session result: ', error)
          )
      } else {
        await updateSession(this.props.sessionDb, this.props.sessionDbTable, data)
      }
    }

    this.props.resetPainLevelsAndSessionId()
    setTimeout(
      () =>
        this.props?.isPro
          ? this.setState({ isProAfterPain: true })
          : history.replace('/indication-select'),
      500
    )
  }

  render() {
    const selectedPainLevel = this.isBefore
      ? this.props.painLevelBefore
      : this.props.painLevelAfter

    if (!this.state.isProAfterPain)
      return (
        <section
          ref={this.mainElement}
          {...SpecialKeysReact.events}
          tabIndex="1"
          className="section offset_v2_mod"
        >
          {/* TODO: Hide steps until they are fixed */}
          {/* <Steps active={3} /> */}
          <div className="section_in center_content_mod">
            <button
              ref={this.backBtn}
              className="player_control_item drop_mod"
              onClick={() => {
                const redirect = this.props.isDoctor ? `/welcome-doctor` : '/song-select'

                history.push(redirect)
              }}
            >
              <img className="controls_btn_icon" src={BackIcon} alt="player menu icon" />
            </button>
            <div className="pain_list_w">
              <h2 className="section_title offset_v2_mod title_step_center_mod pain_mod">
                <div className="section_title_step pain_mod">
                  {this.isBefore ||
                  this.props.indicationType === SLEEP ||
                  this.props.indicationType === AWAKENING ? (
                    <span className="section_title_number three">3</span>
                  ) : (
                    <span className="section_title_number three">4</span>
                  )}
                </div>
                {this.props.indicationType === ANXIETY
                  ? t('pain.INDICATE_ANXIETY')
                  : t('pain.INDICATE_PAIN')}
              </h2>
              <div className="section_descr center_level_mod">
                {t(`pain.SCALE_SELECT_PAIN_${this.isBefore ? 'BEFORE' : 'AFTER'}`)}
              </div>
              <div className="pain_list">
                <div className="pain_list_label">
                  {this.props.indicationType === ANXIETY
                    ? t('pain.NO_ANXIETY')
                    : t('pain.NO_PAIN')}
                </div>
                {range(0, 11).map((rating, index) => (
                  <PainRatingRadioButton
                    key={rating}
                    rating={rating}
                    choosePainRatingHandler={this.choosePainRatingHandler}
                    {...(selectedPainLevel === rating && {
                      checked: true,
                    })}
                    index={index}
                    currentPain={this.state.currentPain}
                    painRef={this.painRef}
                  />
                ))}
                <div className="pain_list_label">
                  {' '}
                  {this.props.indicationType === ANXIETY
                    ? t('pain.MAX_ANXIETY')
                    : t('pain.MAX_PAIN')}
                </div>
              </div>
            </div>
          </div>
          <div className="player_bottom_wrap">
            <Logo />
          </div>
        </section>
      )

    const currency = this.props.licenses.currency === 'EUR' ? '€' : '$'
    const price = this.props.licenses.patientSubscriptionPrice
    const priceWithDecimals = price.toFixed(2)
    const formattedPrice =
      this.props.licenses.currency === 'EUR'
        ? priceWithDecimals.replace('.', ',')
        : priceWithDecimals
    const freeDays = this.props.licenses.freeDays
    const invitePatientDescription =
      freeDays > 0 && price > 0
        ? 'pain.INVITE_PATIENT_DESCR_FREEDAYS_PRICE'
        : price > 0 && freeDays === '0'
        ? 'pain.INVITE_PATIENT_DESCR_NOFREEDAYS_PRICE'
        : 'pain.INVITE_PATIENT_DESCR_NOPRICE'

    const closePath = this.props.isDoctor ? `/welcome-doctor` : '/indication-select'

    return (
      <section className="section offset_v2_mod session_type_mod">
        <button
          className="alarm_block_remove pain_invite_mod"
          onClick={() => history.replace(closePath)}
        >
          <CloseIcon className="icon close_mod size_mod" />
        </button>
        <div className="section_in center_content_mod">
          <div className="section_heading offset_mod">
            <h2 className="section_title center_mod title_step_center_mod email_pain_mod">
              {t('pain.INVITE_PATIENT')}
            </h2>
          </div>

          <div className="session_type_descr default_text">
            <p>
              {t(invitePatientDescription, {
                currency,
                freeDays,
                price: formattedPrice,
                plural: this.props.licenses.freeDays === 1 ? '' : 's',
              })}
            </p>
          </div>
          <Formik
            initialValues={{ email: '', termsCheck: false }}
            validationSchema={sendEmailSchema}
            onSubmit={async ({ email, termsCheck }) => {
              this.props.resetAuthError()
              if (!termsCheck) return this.props.authFail('INVITE_TERMS_UNCHECKED')

              this.setState({ isLoading: true })

              const { error } = await inviteApi.sendInvite({ email })

              this.setState({ isLoading: false })

              if (error) return this.props.authFail(error)

              this.setState({ success: true })
            }}
          >
            {({ errors, touched, submitForm, status, setStatus, isValid }) => (
              <Form style={{ width: '100%' }}>
                <div className="">
                  {!this.state.success && (
                    <div className="email_invite_form_item message_box">
                      <AuthErrorBox
                        formFields={['email']}
                        formTouched={touched}
                        formErrors={errors}
                        apiResponseError={this.props.authError || ''}
                        resetApiResponseError={this.props.resetAuthError}
                        clickedSubmit={status === 'clicked'}
                        className="email_invite"
                      />
                    </div>
                  )}
                  {this.state.success && isValid ? (
                    <div className="email_invite_form_item message_box">
                      <div className="success_text form_success email_invite">
                        {t('pain.EMAIL_SUCCESSFULLY_SENT')}
                      </div>
                    </div>
                  ) : null}
                  <div className="email_invite_form_item input_field">
                    <Field
                      className={`form_field v4_mod email_invite_mod ${
                        status === 'clicked' && errors.email ? 'error' : ''
                      }`}
                      type="email"
                      name="email"
                      placeholder={t('pain.ENTER_EMAIL')}
                      disabled={this.state.isLoading || this.state.success}
                    />
                  </div>
                  <div className="form_controller login_mod size_mod">
                    <CheckboxItem
                      mod="v2_mod"
                      name="termsCheck"
                      id="invite_checkbox"
                      label={
                        <>
                          {t('pain.LEGAL_DISCLAIMER_1')}
                          <a
                            className="label_link"
                            href="https://www.music.care/conditions-pro.html"
                            target="_blank"
                            rel="noopener"
                          >
                            {t('pain.LEGAL_LINK')}
                          </a>
                          {t('pain.LEGAL_DISCLAIMER_2')}
                        </>
                      }
                      disabled={this.state.isLoading || this.state.success}
                    />
                  </div>
                  <div className="email_invite_form_item submit_btn">
                    <LoadingButton
                      noBtnBase
                      disabled={this.state.success}
                      isLoading={this.state.isLoading}
                      className="session_type_item_btn email_invite_mod"
                      onClick={() => {
                        setStatus('clicked')
                        submitForm()
                      }}
                    >
                      {t('pain.SEND')}
                    </LoadingButton>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="player_bottom_wrap">
          <div className="player_bottom v2_mod">
            <Logo modClass="bar_mod" />
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = ({
  auth: { userId, isPro, error, attributes, isDoctor },
  player: {
    playedTime,
    painLevelAfter,
    painLevelBefore,
    songId,
    sessionId,
    indicationType,
    endEvent,
    sessionDb,
    sessionDbTable,
    sessionOnline,
  },
}) => ({
  licenses: attributes?.licenses,
  playedTime,
  authError: error,
  isPro,
  userId,
  painLevelAfter,
  painLevelBefore,
  songId,
  sessionId,
  indicationType,
  isDoctor,
  endEvent,
  sessionDb,
  sessionDbTable,
  sessionOnline,
})

const mapDispatchToProps = {
  addSongToHistory,
  authFail,
  resetAuthError,
  resetPainLevelsAndSessionId: () => (dispatch) =>
    dispatch({ type: RESET_PAIN_LEVELS_AND_SESSION_ID }),
  setPainLevelAfter: (painLevelAfter) => (dispatch) =>
    dispatch({
      payload: painLevelAfter,
      type: SET_PAIN_AFTER_LEVEL,
    }),
  setPainLevelBefore: (painLevelBefore) => (dispatch) =>
    dispatch({
      payload: painLevelBefore,
      type: SET_PAIN_BEFORE_LEVEL,
    }),
}

export default connect(mapStateToProps, mapDispatchToProps)(PainRatingPage)

const PainRatingRadioButton = ({
  rating,
  choosePainRatingHandler,
  painRef,
  index,
  currentPain,
}) => (
  <div className="pain_item">
    <label className="radio_check radio_1_mod">
      <input
        ref={(btn) => (painRef.current[index] = btn)}
        className="radio_check_input"
        type="radio"
        id={rating}
        name="radio"
        checked={index === currentPain ? true : false}
        onChange={() => choosePainRatingHandler(rating)}
      />
      <div className="radio_label_block">
        <div className="radio_in"></div>
      </div>
      <span className="radio_check_text radio_1_mod">{rating}</span>
    </label>
  </div>
)
